   export const endpoints = {
      "admin": "/notification/getNotificationsForAdmin?page=1&limit=2",
      "business user": "/notification/getNotifications?page=1&limit=2",
      "employee user": "/notification/getNotifications?page=1&limit=2",
      "normal user": "/notification/getNotifications?page=1&limit=2",
      "delivery user": "/notification/getNotifications?page=1&limit=2",
    };